import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderJson(source) {
    const parts = split(source);
    const result = [];
    const isString = false;
    let isProperty = true;
    for (const token of parts) {
        if (token === ',' || token === '{') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            isProperty = true;
            continue;
        }
        if (token === ':') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            isProperty = false;
            continue;
        }
        if (token === '(' ||
            token === ')' ||
            token === '{' ||
            token === '}' ||
            token === '[' ||
            token === ']') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            continue;
        }
        const color = isProperty ? Colors.attributeNameColor : Colors.attributeValueColor;
        result.push(_jsx("span", { style: { color: color }, children: token }));
    }
    return result;
}
